<style lang="scss">
@import "../styles/document-spinner.scss";
</style>

<template>
  <transition name="slide-fade">
    <div class="document-spinner" v-if="isVisible">
      <div class="lds-dual-ring"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "DocumentSpinner",
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  }
};
</script>
